export const HARD_CODED_ISRAEL_VAT = 1.18;
export const HARD_CODED_LABOR_DESK_VAT = 1.2;
export const HARD_CODED_ISRAEL_VAT_PRECENTAGE = 18;
export const HARD_CODED_LABOR_DESK_VAT_PRECENTAGE = 20;

export const XENIA_MILAGE_NUMBER_PAYROLL_FIELD_ID = 203;
export const THE_DUTCH_MILAGE_NUMBER_PAYROLL_FIELD_ID = 478;
export const YELLOW_STRIPE_BEER_NUMBER_PAYROLL_FIELD_ID = 222;
export const ELOCKER_DISTANCE_NUMBER_PAYROLL_FIELD_ID = 252;
export const SPE_MILAGE_NUMBER_PAYROLL_FIELD_ID = 301;

export const DN_WAIT_TIME_CODE_PAYROLL_FIELD_ID = 536;
export const DN_WAIT_TIME_DURATION_PAYROLL_FIELD_ID = 537;
export const DN_WAIT_TIME_TOTAL_PAYROLL_FIELD_ID = 538;

export const CONSTELLATION_NL_DISTANCE_NUMBER_PAYROLL_FIELD_ID = 880;

const CUSTOM_LEGENDS_US_BARCLAYS_MEAL_ALLOWANCE_PAYROLL_FIELD_ID = 1284;
export const EDITABLE_CUSTOM_NUMBER_PAYROLL_FIELD_IDS = [CUSTOM_LEGENDS_US_BARCLAYS_MEAL_ALLOWANCE_PAYROLL_FIELD_ID];

export const PAYROLL_FIELDS_WITHOUT_CURRENCY = [
  XENIA_MILAGE_NUMBER_PAYROLL_FIELD_ID,
  YELLOW_STRIPE_BEER_NUMBER_PAYROLL_FIELD_ID,
  ELOCKER_DISTANCE_NUMBER_PAYROLL_FIELD_ID,
  SPE_MILAGE_NUMBER_PAYROLL_FIELD_ID,
  THE_DUTCH_MILAGE_NUMBER_PAYROLL_FIELD_ID,
  DN_WAIT_TIME_CODE_PAYROLL_FIELD_ID,
  DN_WAIT_TIME_DURATION_PAYROLL_FIELD_ID,
  DN_WAIT_TIME_TOTAL_PAYROLL_FIELD_ID,
  CONSTELLATION_NL_DISTANCE_NUMBER_PAYROLL_FIELD_ID
];
